import { render } from "./TextPage1.vue?vue&type=template&id=acf39ca4"
import script from "./TextPage1.vue?vue&type=script&lang=js"
export * from "./TextPage1.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__